import React, { useState, useEffect } from "react";
import { firebaseObserver } from "../utils/firebase";
import NotSignedIn from "./NotSignedIn";
import { _tryJoinGroup, _claimMember, _getGroupInvitation, _addAsNewGroupMember } from "../data/groupInvitation.js";
import { useNavigate } from "react-router-dom";
import { _isUserInGroup } from "../data/users";
import { toggleModal } from "../utils/uiUtils.js";
import Loading from "./partial/Loading.js";
import LoadingModal from "./partial/LoadingModal.js";
import GroupHeader from "./partial/GroupHeader..js";
import joinGroupFailureMessage from "../enums/joinGroupFailureMessage.js";
import { useAuthStore } from "../stores/useAuthStore.js";

const Failure = React.lazy(() => import("./partial/Failure.js"));

function JoinGroup({ invitationToken }) {
    const [invitationDetail, setInvitationDetail] = useState({});
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [hasJoinedGroup, setHasJoinedGroup] = useState(false);
    const [joinGroupError, setJoinGroupError] = useState("");
    const [unclaimedMembers, setUnclaimedMembers] = useState([]);
    const [hasInvitationError, setHasInvitationError] = useState(false);
    const [groupId, setGroupId] = useState("");
    const navigate = useNavigate();
    const displayName = useAuthStore((state) => state.displayName);

    useEffect(() => {
        async function getInvitation(token) {
            var tmpInvitationDetail = await _getGroupInvitation(token);
            if (tmpInvitationDetail == null) {
                setHasInvitationError(true);
                return;
            }

            setInvitationDetail(tmpInvitationDetail);
            setGroupId(tmpInvitationDetail.groupId);
        }

        
        firebaseObserver.subscribe('authStateChanged', isUserLoggedIn => {
            setIsLoggedIn(isUserLoggedIn);
            if (isUserLoggedIn) {
                getInvitation(invitationToken);
                _isUserInGroup(groupId).then((isInGroup) => {
                    if (isInGroup) {
                        navigate(`/group/${groupId}`);
                    }

                    setIsLoading(false);
                });
            } else {
                setIsLoading(false);
            }
        });
    }, []);

    const tryJoinGroup = async () => {
        toggleModal("loadingModal");
        var response = await _tryJoinGroup(invitationToken);
        toggleModal("loadingModal");

        if (response.success == null || response.success === false) {
            var reason = "Something went wrong. Try again later or with a new invitation link";
            if (response.reason && joinGroupFailureMessage[response.reason]) {
                reason = joinGroupFailureMessage[response.reason];
            }
            setJoinGroupError(reason);
            toggleModal("modal-error");
            return;
        }

        if (response.success) {
            setUnclaimedMembers(response.unclaimedMembers);
            setHasJoinedGroup(true);
        }
    }

    const claimMember = () => {
        var memberId = document.querySelector('input[name="pickMember"]:checked').value;
       
        if (memberId !== "-1") {
            if (!displayName) {
                displayName = "";
            }
            _claimMember(groupId, memberId, displayName);
        } else {
            _addAsNewGroupMember(groupId, displayName);
        }

        navigate(`/group/${groupId}`);
    }

    return (
        <>
            <LoadingModal />
            {isLoading ? (
                <Loading />
            ) : hasInvitationError ?
                <>
                   <Failure message={"Unable to join group at this time. Try again later, or get a new invitation link, yours may have expired."} />
                </>
                : isLoggedIn && !hasJoinedGroup ? (
                    <>
                        <GroupHeader headerImage={invitationDetail.groupHeader} groupName={invitationDetail.groupName} />
                        <div className="columns">
                            <div className="column is-12 is-offset-2">
                                <div className="title">
                                    Join Group
                                </div>
                                <p>You've been invited to join a board game group!
                                </p>
                                <p>
                                    This invitation expires at {invitationDetail.expires}. After that you will need a new invitation link.
                                </p>
                                <p className="mb-5">
                                    Once you join the group you will be able to see game scores, add your own game sessions and scores, and invite other members.
                                </p>
                                <button className="button mr-5 has-background-success-dark has-text-light" onClick={() => tryJoinGroup()}>Join Group</button>
                                <button className="button ml-5 has-background-danger has-text-light" onClick={() => navigate('/')}>Cancel</button>

                                <div className="is-hidden has-text-danger has-text-weight-bold" id="inviteError">
                                </div>
                            </div>
                        </div>
                        <div id="modal-error" className="modal">
                            <div className="modal-background"></div>
                            <div className="modal-card">
                                <header className="modal-card-head has-text-centered">
                                    <p className="modal-card-title">Could Not Join Group</p>
                                    <button className="delete" aria-label="close" onClick={() => { document.getElementById('modal-error').classList.remove('is-active') }}></button>
                                </header>
                                <section className="modal-card-body">
                                    <div className="is-size-6">
                                        {joinGroupError}
                                    </div>
                                </section>
                                <footer className="modal-card-foot">
                                    <button className="button" aria-label="close" onClick={() => { document.getElementById('modal-error').classList.remove('is-active') }}>Close</button>
                                </footer>
                            </div>
                        </div>

                    </>
                ) : isLoggedIn && hasJoinedGroup ? (
                    <>
                        <GroupHeader headerImage={invitationDetail.groupHeader} groupName={invitationDetail.groupName} />
                        <div className="is-align-content-center p-4">
                            Is one of these unclaimed members you? <span className="has-text-weight-bold">Choosing a user cannot be undone and the name will change to match your display name.</span>
                            <ul>
                                {Object.entries(unclaimedMembers).map(([memberId, displayName], index) => (
                                    <li key={index}><input type="radio" name="pickMember" value={memberId} /> {displayName}</li>
                                ))}
                                <li><input type="radio" name="pickMember" value="-1" /> None, create a new member for me</li>
                            </ul>
                            <button className="button has-background-success-dark has-text-light" onClick={() => { claimMember(); }}>Continue</button>
                        </div>
                    </>
                ) :
                    (
                        <NotSignedIn />
                    )}
        </>
    );
}

export default JoinGroup;